const {
  interceptNativeSubmit,
  subscribeToNewsletter,
  wasFormPosted,
} = window.BAO.Utils

class ProductTabNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'form',
      'email',
      'error',
      'subscribe-text',
      'success-text',
      'subscribe-form',
      'copy-text',
    ]
  }

  constructor () {
    super()

    this.signupSource = 'pdp_drawer'
    this.submittedStorageName = 'BAO-drawer3-newsletter-submitted'
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.shouldShowPopup()) {
      this.externalEls.trigger.element.style.display = 'none'
      this.externalEls.container.element.style.display = 'none'
    }

    this.setupListeners()

    // Back from a native or `/challenge` submission that Shopify accepted.
    if (wasFormPosted(this.els.form.element)) {
      this.revealPostedSuccess()
    }
  }

  // The form sits in a tab that isn't selected by default, so select it and scroll to it.
  async revealPostedSuccess () {
    this.showSubscribedMessage()

    await customElements.whenDefined('accordion-group')

    const tab = this.externalEls.trigger?.element
    if (tab?.getAttribute('aria-selected') !== 'true') tab?.click()

    window.requestAnimationFrame(() => this.scrollIntoView({ block: 'center' }))
  }

  setupListeners () {
    super.setupListeners()

    this.submitForm = interceptNativeSubmit(
      this.els.form.element,
      () =>
        this.createClientSubscription({
          emailAddress: this.els.email.element.value.replace(/\s/g, ''),
        }),
      { source: this.signupSource },
    )

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onFormSubmit.bind(this),
    )

    this.listeners.add(
      this.els.email.element,
      'input',
      this.handleEmailInput.bind(this),
    )

    this.listeners.add(
      this.els.code.element,
      'click',
      this.handleCodeCopy.bind(this),
    )
    this.listeners.add(
      this.els['copy-text'].element,
      'click',
      this.handleCodeCopy.bind(this),
    )
  }

  handleCodeCopy () {
    const code = this.els.code.element.innerText
    navigator.clipboard.writeText(code)

    this.els['copy-text'].element.innerText = this.els[
      'copy-text'
    ].element.getAttribute('data-copied-text')
  }

  handleEmailInput () {
    if (this.validEmail()) {
      this.els.email.element.setAttribute('aria-invalid', false)
    } else {
      this.els.email.element.setAttribute('aria-invalid', true)
    }
  }

  async onFormSubmit (e) {
    e.preventDefault()

    if (!this.validEmail()) {
      // Stop Shopify's own submit listeners from sending an invalid form.
      e.stopImmediatePropagation()
      this.els.email.element.setAttribute('aria-invalid', true)
      this.els.email.element.focus()
      return
    }

    // To-do: Run Ometria account lookup

    this.submitForm()
  }

  async createClientSubscription (formData) {
    const { emailAddress } = formData

    const subscribed = await subscribeToNewsletter(emailAddress, {
      source: this.signupSource,
      form: this.els.form.element,
    })

    if (!subscribed) {
      this.toggleErrorMessage(window.theme.strings.newsletterGenericError)
      return
    }

    this.toggleErrorMessage()
    this.showSubscribedMessage()
  }

  toggleErrorMessage (message = false) {
    const errorElement = this.els.error.element
    if (!message) {
      errorElement.setAttribute('aria-hidden', true)
    } else {
      errorElement.setAttribute('aria-hidden', false)
      errorElement.innerHTML = message
    }
  }

  showSubscribedMessage () {
    window.localStorage.setItem(this.submittedStorageName, true)

    // Hide subscribe form
    this.els['subscribe-text'].element.setAttribute('aria-hidden', true)
    this.els['subscribe-form'].element.setAttribute('aria-hidden', true)

    // // Show registered text
    this.els['success-text'].element.setAttribute('aria-hidden', false)
  }

  validEmail () {
    const emailAddress = this?.els?.email?.element?.value.replace(/\s/g, '')

    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return emailRegex.test(emailAddress)
  }

  /*
  change this to should show newsletter, and hide newsletter instead
  */
  shouldShowPopup () {
    let shouldShow = true

    // Don't show if popup has already been submitted
    if (window.localStorage.getItem(this.submittedStorageName) !== null) {
      shouldShow = false
    }

    return shouldShow
  }
}

if (!customElements.get('product-tab-newsletter')) {
  customElements.define('product-tab-newsletter', ProductTabNewsletter)
}
